import {useDeleteElementoMutation, useGetElementiQuery, useInsertElementoMutation, useLazyGetElementoQuery, useUpdateElementoMutation} from "@commons/features/elementiRML/ElementiRML.api";
import React from "react";
import {normalizeStr, useQueryFilter} from "@components/dataTable/customHooks";
import {SearchParamsType, usePagination} from "@components/dataTable/usePagination";
import {useClientSideProcessing} from "@components/dataTable/useClientSideProcessing";

import DTTable from "../../../components/dataTable/Table";
import DTTitle from "../../../components/dataTable/TableTitle";
import Pagination from "../../../components/dataTable/Pagination";
import {ElementoRMLRecord} from "@commons/mapping/ElementoRMLRecord";
import ElementoRMLEditor from "./form";
import {Tab} from "@headlessui/react";
import {CreateButton, useEditor} from "../../../core/editor";
import * as Buttons from "../../../components/dataTable/buttons";

export default function ElementiRMLPage() {

    function searchFn1(sp: SearchParamsType, element: ElementoRMLRecord, index: number, array: ElementoRMLRecord[]) {
        return normalizeStr(element.codElemento).indexOf(normalizeStr(sp.value)) >= 0 ||
            normalizeStr(element.descrizione).indexOf(normalizeStr(sp.value)) >= 0;
    }

    const pagination = usePagination('',1, 10);
    const {page, setPage, pageLength, setPageLength, search, setSearch} = pagination;
    const {filter, skip} = useQueryFilter<any>({}, pagination);
    const {data} = useGetElementiQuery(filter, {skip});
    const localData = useClientSideProcessing<ElementoRMLRecord, keyof ElementoRMLRecord>(data, pagination, ['codElemento', 'descrizione']);
    //const localData = useClientSideProcessing<ElementoRMLRecord, keyof ElementoRMLRecord>(data, pagination, searchFn1);
    const {resource, create, cancel, URI, loadResource, saveResource, deleteResource} = useEditor<ElementoRMLRecord>(
        useInsertElementoMutation()[0],
        useLazyGetElementoQuery()[0],
        useUpdateElementoMutation()[0],
        useDeleteElementoMutation()[0])

    //console.log(process.env.NODE_ENV);

    return (<>
        <div className="px-2 py-3 bg-gray-200 rounded-lg">
            <div className="m-2">
                <div className="relative">
                    <div className="absolute right-2">
                        <CreateButton<ElementoRMLRecord> create={create} label="Elemento"/>
                    </div>
                </div>
                <Tab.Group>
                    <Tab.List className="tab-list">
                        <Tab className="tab">Propriet&agrave;</Tab>
                    </Tab.List>
                    <Tab.Panels className="tab-panels">
                        <Tab.Panel>
                            {resource && <div className="p-3">
                                <ElementoRMLEditor resource={resource} onSubmit={saveResource} onCancel={cancel}></ElementoRMLEditor>
                            </div>}
                        </Tab.Panel>
                    </Tab.Panels>
                </Tab.Group>
            </div>
        </div>

        <DTTitle id="elencoAziende" title="Elementi RML" {...{currentPageLength: pageLength, setPageLength, currentSearch: search, setSearch}}/>

        <DTTable<ElementoRMLRecord> dtSchema={localData}
                                    header={<>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                            Codice
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                            Descrizione
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                            Tipo
                                        </th>
                                        <th scope="col" className="py-3.5 w-14"/>
                                    </>}

                                    rows={({item, index, isMobile, currentRow, register}) => (
                                        <tr {...register(item.codElemento!, index, item.URI === URI)}>
                                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6">
                                                {item.codElemento}
                                            </td>

                                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6">
                                                {item.descrizione}
                                            </td>
                                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6">
                                                {item.elementoDiscrezionale ? 'Discrezionale' : 'CCNL'}
                                            </td>

                                            <td className="whitespace-nowrap py-2 text-sm font-medium">
                                                <Buttons.Visibility visible={isMobile || index === currentRow}>
                                                    <Buttons.Edit onAction={() => loadResource(item.URI)}/>
                                                    <Buttons.Delete onConfirm={() => {
                                                        deleteResource(item.URI!)
                                                    }}/>
                                                </Buttons.Visibility>
                                            </td>
                                        </tr>)
                                    }
        />

        <Pagination dataTables={localData} currentPage={page} setPage={setPage} currentPageLength={pageLength}></Pagination>
    </>)
}